import { watch, ref, nextTick } from 'vue'
import Config from '@/config/index'
import emojiList from '../components/emojiPicker/config'
import { queryPhraseClassifyByName, upDatePhraseClassifyNum } from '@/api/chat'
import { useStore } from 'vuex'
import { message as Message } from 'ant-design-vue'
import { base64toFile } from '@/views/WorkPlace/Container/chat/components/contenteditable/clipboard'
import { chatGroupTabsKeyEnum } from '@/utils/globalMap'
export default function useCommonWords(activeKey, chatToType, saveFile, chatInfoGroupTabs) {
  const visiblePopover = ref(false)
  const store = useStore()
  const commonWordRef = ref(null)
  const commonwordsList = ref([])
  const keyword = ref('') // 联想关键字
  const message = ref('') //输入框文本
  const userId = store.getters.userId + ''
  const recentEmoji = ref(JSON.parse(localStorage.getItem(userId)) || []) //最近使用表情
  const maxLength = 1000

  //来引用 editor DOM 元素。
  const editor = ref(null)
  //ai 引用
  const aiRef = ref(null)
  // 用于保存光标位置。
  let savedRange = null
  //输入事件
  const handleInput = async e => {
    try {
      // 计算文本长度，这里可以考虑是否包含中文字符的处理，如果是英文和数字，length足够
      // 对于包含中文等多字节字符，可能需要更复杂的计算方式
      // // 如果超过500个字符，则裁剪掉超出的部分
      if (e.length > maxLength) {
        editor.value = editor.value.substring(0, maxLength)
        console.log(e.length)
        // 防止因为裁剪导致的无限循环调用 input 事件
      }
      //判断message是否为空
      if (!e) return (visiblePopover.value = false)
      const { endContainer } = window.getSelection().getRangeAt(0)
      //光标所在文本域
      const { data } = endContainer
      const result = data.match(/#(.*)/)
      // 判断关键值是否存在
      if (!data || !result || !result[1]) return (visiblePopover.value = false)
      //关键值赋值
      keyword.value = result[1]
      const res = await queryPhraseClassifyByName({ chatContent: keyword.value })
      if (res) {
        commonwordsList.value = res || []
        visiblePopover.value = !!commonwordsList.value.length
      } else {
        commonwordsList.value = []
        visiblePopover.value = false
      }
    } catch (error) {
      commonwordsList.value = []
      visiblePopover.value = false
    }
  }
  //  更新常用语次数
  const upDateNum = id => {
    upDatePhraseClassifyNum({ id })
  }
  //  页面一挂载即获取焦点
  const focusEditor = () => {
    if (editor.value && editor.value.$el) {
      editor.value.$el.focus()
    }
  }
  //blur 事件时调用，保存当前的光标位置。
  const saveSelection = () => {
    const selection = window.getSelection()
    if (selection.rangeCount > 0) {
      savedRange = selection.getRangeAt(0)
    }
  }
  //在 focus 事件时调用，恢复之前保存的光标位置。
  const restoreSelection = () => {
    const selection = window.getSelection()
    if (savedRange) {
      selection.removeAllRanges()
      selection.addRange(savedRange)
    }
  }
  //用于插入节点，首先恢复光标位置，然后使用 Range API 删除现有内容并插入新的节点。
  const insertContent = node => {
    // const currentLength = editor.value.modelValue.length
    // 规定的最大字符数
    // const maxChars = 1000
    // // 判断是否超出最大字符数
    // if (currentLength >= maxChars) {
    //   // 可选：向用户显示提示信息
    //   // alert(`字符数已达到最大限制，无法继续插入表情。`)
    //   return // 终止插入操作
    // }
    const selection = window.getSelection()
    restoreSelection()
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0)
      range.deleteContents()
      range.insertNode(node)
      range.setStartAfter(node)
      range.setEndAfter(node)
      selection.removeAllRanges()
      selection.addRange(range)
    }
    console.log(message.value)
  }
  const keepRecentEmoji = item => {
    const index = recentEmoji.value.findIndex(e => e.code === item.code)
    if (index > -1) {
      recentEmoji.value.splice(index, 1) // 移除已有的表情
    }
    recentEmoji.value.unshift(item) // 添加到最前面
    if (recentEmoji.value.length > 10) {
      recentEmoji.value.pop() // 保持最大长度为10
    }
  }
  //创建一个 <auth-img> 元素，并设置其 src 属性为表情图片的 URL，然后调用 insertContent 方法插入该图片。
  const insertEmoji = (item, flag = true) => {
    console.log(item)
    flag && keepRecentEmoji(item)
    // if (editor.value.modelValue.length > maxLength) {
    //   return
    // }
    const img = document.createElement('img')
    img.src = item.iconPath
    img.style.width = '24px' // 设置图片宽度
    img.style.height = '24px' // 设置图片高度
    img.style.margin = '0 5px'
    insertContent(img)
    //兼容初次加入表情无法触发绑定问题
    console.log(img.outerHTML)
  }
  //创建一个文本节点，然后调用 insertContent 方法插入该文本节点。
  const insertText = text => {
    const textNode = document.createTextNode(text)
    console.log(textNode)
    insertContent(textNode)
    console.log(textNode)
  }
  //方法用于替换 endContainer 的 data
  const replaceEndContainerData = (newVal = '') => {
    restoreSelection()
    const selection = window.getSelection()
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0)
      const endContainer = range.endContainer
      if (endContainer.nodeType === Node.TEXT_NODE) {
        const match = endContainer.textContent.match(/(.*)#/)
        console.log(match)

        if (match) {
          const newContent = match[1]
          console.log(newContent)
          endContainer.textContent = newContent + newVal
          console.log(endContainer.textContent)
          // message.value = (message.value || '') + endContainer.textContent
          range.setStart(endContainer, endContainer.textContent.length)
          range.setEnd(endContainer, endContainer.textContent.length)
          selection.removeAllRanges()
          selection.addRange(range)
        }
      } else {
        for (const node of endContainer.childNodes) {
          if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = newVal
            break
          }
        }
      }
    }
  }
  //关闭话术提示
  const closePopover = () => {
    visiblePopover.value = false
    focusEditor()
  }
  //替换 <auth-img> 标签为相应的 label
  const convertImgToLabel = html => {
    // 创建一个临时容器来处理 HTML 字符串
    const container = document.createElement('div')
    container.innerHTML = html
    // 替换 <auth-img> 标签为相应的 label
    const imgElements = container.querySelectorAll('img')
    imgElements.forEach(img => {
      const src = img.src
      const emoji = emojiList.find(e => e.iconPath === src)
      if (emoji) {
        const labelNode = document.createTextNode(emoji.label)
        img.parentNode.replaceChild(labelNode, img)
      } else {
        const labelNode = document.createTextNode('')
        img.parentNode.replaceChild(labelNode, img)
      }
    })
    // 替换 <br> 标签为换行符，并处理连续的 <br> 标签
    const htmlWithLineBreaks = container.innerHTML
      .replace(/(<br\s*\/?>|<br>)/g, '\n')
      .replace(/\n+/g, '\n')

    // 替换 </div> 和 <div> 标签，移除所有 div 标签
    const htmlWithDivsHandled = htmlWithLineBreaks
      .replace(/<div[^>]*>/g, '')
      .replace(/<\/div>/g, '')

    // 去掉头尾的换行符和空格
    const cleanedString = htmlWithDivsHandled
      .trim()
      .replace(/&(nbsp|amp|lt|gt);/gi, (match, entity) => {
        switch (entity) {
          case 'nbsp':
            return ' '
          case 'amp':
            return '&'
          case 'lt':
            return '<'
          case 'gt':
            return '>'
          default:
            return match // 如果是未知实体，保持原样
        }
      })
    // 返回最终的字符串
    return cleanedString
  }
  const replaceEmojiCodesWithImages = text => {
    // 直接在文本上使用正则表达式替换emoji标签
    return emojiList.reduce((accumulator, emoji) => {
      // 对于每个emoji，创建一个正则表达式，并全局替换文本中的emoji标签
      const regex = new RegExp(emoji.label.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g')
      // console.log(emoji)
      return accumulator.replace(regex, `<img src="${emoji.iconPath}" style="width:24px" />`)
    }, text)
  }
  //消息重新编辑
  const copyMessage = value => {
    message.value = replaceEmojiCodesWithImages(value)
  }
  // 将文本中的大陆手机号渲染为可点击拨号链接
  const linkPhone = html => {
    // 仅匹配 11 位大陆手机号，前后需非数字边界，避免命中订单号/身份证等长数字
    return html.replace(/(?<![\d])1[3-9]\d{9}(?![\d])/g, match => {
      return `<a class="tel-link" data-tel="${match}">${match}</a>`
    })
  }
  //文字渲染 换行
  // isSelf 为 true（自己发送的消息）时跳过蓝链，手机号保持原样式
  const renderTxt = (txt = '', isSelf = false) => {
    const html = replaceEmojiCodesWithImages(txt.trim().replace(/\n|\\n/g, '<br>'))
    return isSelf ? html : linkPhone(html)
  }
  //双击复制
  const doubleClick = async (msg, id) => {
    const val = document.getElementById(id)
    window.getSelection().selectAllChildren(val)
    document.execCommand('Copy')
    try {
      await document.execCommand('Copy') // 执行浏览器复制命令
      Message.success('复制成功')
    } catch {
      Message.error('复制失败')
    }
  }
  // 获取当前群组tab的key
  const getGroupTabKey = key => {
    const chatTabInfo = chatInfoGroupTabs.value.find(
      item => item.groupId === activeKey.value || item.groupId === key
    )
    return chatTabInfo?.key
  }
  //发送消息
  const onSendTextMsg = () => {
    // 是否是医生私聊群
    const isDoctorPrivate = getGroupTabKey() === chatGroupTabsKeyEnum.医生私聊
    const mapSendFun = {
      text(content) {
        const sendMsg = (convertImgToLabel(content) || '').trim()
        if (!sendMsg) {
          Message.warning('发送内容不能为空！')
          return
        }
        store.dispatch('onSendText', {
          chatType: 'group',
          chatId: activeKey.value,
          message: sendMsg,
          chatToType: chatToType.value,
          ext: {
            is_doctor_private: isDoctorPrivate
          }
        })
      },
      img(base64) {
        const file = base64toFile(base64)
        const _file = {
          data: file,
          filename: file.name,
          filetype: file.name.slice(-3)
        }
        // console.log('用户选择的图片=======>', _file)
        if (!_file.filename) {
          return Message.error('文件异常')
        }
        if (!Config.IMG_TYPE[_file.filetype.toLowerCase()]) {
          return Message.error('图片格式仅支持png/jpg/jpeg / 图片仅限10M以内')
        }
        const obj = {
          chatType: 'group',
          chatId: activeKey.value,
          file: _file,
          chatToType: chatToType.value,
          ext: {
            is_doctor_private: isDoctorPrivate
          },
          callback: () => {}
        }
        store.dispatch('sendImgMessage', obj)
      }
    }
    const sends = editor.value.getSendsData()
    sends.forEach(send => {
      const { type, content } = send
      mapSendFun[type](content)
    })
    message.value = ''
    saveFile(activeKey.value)
    aiRef.value && aiRef.value.closeWindow()
  }
  //键盘事件
  const handleKeydown = event => {
    if (event.key === 'Enter') {
      if (event.shiftKey) {
        // Shift + Enter: 插入换行符
        // 目前采用默认换行事件 用下面的方法可以实现自定义
        // event.preventDefault() // 阻止默认行为（插入新的段落）
      } else {
        event.preventDefault()
        editor.value.update()
        // Enter: 触发指定事件
        // 阻止默认行为（插入新的段落）
        nextTick(() => {
          onSendTextMsg()
        })
      }
    }
  }
  //话术库自动匹配选择
  const handlePick = async record => {
    await replaceEndContainerData('')
    insertText(record.chatContent)
    visiblePopover.value = false
    upDateNum(record.id)
  }
  //话术库选择
  const selectWords = record => {
    insertText(record.chatContent)
    commonWordRef.value.closeDrawer()
    upDateNum(record.id)
  }
  //ai 导出
  const exportMessage = msg => {
    message.value = message.value ? message.value + msg : msg
  }
  //双击复制
  const preventExternalClick = () => {
    const selection = window.getSelection()
    selection.removeAllRanges()
  }
  watch(
    () => recentEmoji,
    newValue => {
      localStorage.setItem(userId, JSON.stringify(recentEmoji.value))
    },
    { deep: true }
  )
  return {
    aiRef,
    visiblePopover,
    commonWordRef,
    commonwordsList,
    keyword,
    message,
    editor,
    recentEmoji,
    maxLength,
    handleInput,
    upDateNum,
    saveSelection,
    restoreSelection,
    insertEmoji,
    insertText,
    replaceEndContainerData,
    convertImgToLabel,
    focusEditor,
    insertContent,
    closePopover,
    copyMessage,
    renderTxt,
    replaceEmojiCodesWithImages,
    doubleClick,
    onSendTextMsg,
    handleKeydown,
    handlePick,
    selectWords,
    exportMessage,
    preventExternalClick,
    getGroupTabKey
  }
}
